import React, { useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

const pages = [
  "/guidelines/page1.jpg",
  "/guidelines/page2.jpg",
  "/guidelines/page3.jpg",
  "/guidelines/page4.jpg",
  "/guidelines/page5.jpg",
  "/guidelines/page6.jpg",
  "/guidelines/page7.jpg",
  "/guidelines/page8.jpg",
  "/guidelines/page9.jpg",
  "/guidelines/page10.jpg",
  "/guidelines/page11.jpg",
  "/guidelines/page12.jpg",
];

export default function Gmfguideline() {
  const book = useRef(null);
  const [page, setPage] = useState(1);

  const nextPage = () => {
    book.current?.pageFlip().flipNext();
  };

  const prevPage = () => {
    book.current?.pageFlip().flipPrev();
  };

  return (
    <>
    <Helmet>
      <title>GMF Guidelines | Gandhi Mandela Foundation</title>
    </Helmet>
      <Header />

      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>GMF Guidelines</span>
          </div>
          <h1>GMF Guidelines</h1>
        </div>
      </section>

      <section className="section">
        <div className="container flipbook-container">

          <HTMLFlipBook
            ref={book}
            width={500}
            height={700}
            size="stretch"
            minWidth={280}
            maxWidth={700}
            minHeight={400}
            maxHeight={900}
            showCover={true}
            mobileScrollSupport={true}
            drawShadow={true}
            onFlip={(e) => setPage(e.data + 1)}
          >
            {pages.map((img, index) => (
              <div className="book-page" key={index}>
                <img src={img} alt={`Page ${index + 1}`} />

                <div className="page-corner top">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>

                <div className="page-corner bottom">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
              </div>
            ))}
          </HTMLFlipBook>

          <div className="page-count">
            Page {page} of {pages.length}
          </div>

          <div className="swipe-hint">
            <i className="fa-solid fa-hand-point-up"></i>
            Swipe or use the buttons below to turn pages
          </div>

          <div className="mobile-controls">
            <button onClick={prevPage}>
              <i className="fa-solid fa-chevron-left"></i> Previous
            </button>

            <button onClick={nextPage}>
              Next <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}